<template>
  <div v-if="visibleAddHomeScreen && checkPassPWA" class="addHomeScreen">
    <div class="close" @click="closeAddHomeScreenMessage">
      <span id="close-ios-prompt" class="close-button">×</span>
    </div>
    <img
      class="my-4 w-75"
      style="opacity: 0.6"
      src="../assets/images/logo/logo-long-01.svg"
      alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
    />
    <!-- <img src="../assets/images/siteImages/AddHomeScreen.svg" alt="" /> -->
    <div class="message">
      <div v-if="isIOS && isSafari">
        <p>
          به منظور نصب برنامه ارگانیک مایندد در تلفن همراه خود می‌توانید مراحل
          زیر را انجام دهید:
        </p>
        <div>
          <div class="addHomeScreenItems">
            <span
              >۱. روی دکمه <span class="text-blueSite fw-bold">Share</span> در
              نوار پایین کلیک کنید.</span
            ><img
              src="../assets/images/siteImages/ShareArrow.svg"
              class="undefined _3ocXi"
              style="opacity: 1"
            />
          </div>
          <div class="addHomeScreenItems">
            <span
              >2. گزینه
              <span class="text-blueSite fw-bold">Add To Home Screen</span>
              را فعال کنید.</span
            ><img
              src="../assets/images/siteImages/AddHomeScreenIcon.svg"
              class="undefined _3ocXi"
              style="opacity: 1"
            />
          </div>
          <div class="addHomeScreenItems">
            <span
              >3. در قسمت بالا روی
              <span class="text-blueSite fw-bold">Add</span> کلیک کنید.</span
            ><img
              src="../assets/images/siteImages/AddIcon.svg"
              class="undefined _3ocXi"
              style="opacity: 1"
            />
          </div>
        </div>
      </div>
      <div v-else>
        برای نصب اپلیکیشن ارگانیک در تلفن همراه خود می‌توانید این صفحه را با
        استفاده از Add To Home Screen به منو خود اضافه کنید
      </div>
      <button
        class="btn btn-sm rounded btn-danger w-100 mt-2"
        @click="closeAddHomeScreenMessage"
      >
        متوجه شدم
      </button>
    </div>
  </div>
  <div>
    <div
      class="swiper-container swiper-btn-group swiper-btn-group-end text-white bannerImageSize overflow-hidden swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
      data-swiper='{
		"slidesPerView": 1,
		"spaceBetween": 0,
		
    "autoplay": { "delay" : 1500, "disableOnInteraction": false }
		"loop": true,
		"pagination": { "type": "bullets" }
	}'
    >
      <div class="swiper-wrapper h-100">
        <!-- Banner slider 1 -->
        <div
          class="slide1 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div>
        <!-- Banner slider 2 -->
        <div
          class="slide2 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div>
        <!-- Banner slider 3 -->
        <div
          class="slide3 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div>
        <!-- Banner slider 4 -->
        <div
          class="slide4 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div>
        <!-- Banner slider 5 -->
        <!-- <div
          class="slide5 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div> -->
        <!-- Banner slider 6 -->
        <!-- <div
          class="slide6 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div> -->
        <!-- Banner slider 7 -->
        <!-- <div
          class="slide7 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div> -->
        <!-- Banner slider 8 -->
        <!-- <div
          class="slide8 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div> -->
        <!-- Banner slider 9 -->
        <!-- <div
          class="slide9 swiper-slide h-100 d-middle bg-white overlay-opacity-3 bg-cover pointer"
          @click="slidImageClick"
        ></div> -->
      </div>

      <!-- Add Arrows -->
      <template v-if="!isMobile">
        <div class="swiper-button-next swiper-button-white"></div>
        <div class="swiper-button-prev swiper-button-white"></div>
      </template>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>

    <div>
      <div
        class="section text-center sectionArticle"
        :class="isMobile ? 'py-5 pb-0' : 'mt-3'"
      >
        <div class="container">
          <h2 v-if="!isMobile" class="fw-bold">آخرین مقاله‌ها</h2>
          <hr v-if="!isMobile" class="bg-gradient-primary my-0 container" />
          <div class="bg-white rounded overflow-hidden">
            <!-- shadow-xs -->

            <div class="row col-border">
              <div
                class="p-0"
                :class="isMobile ? 'col-4' : 'col-12 col-md-12 col-lg-4 mb-4'"
                v-for="item in newArticles"
                :key="item.guid"
              >
                <div
                  class="card border-0 h-100 shadow rounded-xl article-card"
                  :class="isMobile ? '' : 'aos-init aos-animate'"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-offset="0"
                  data-aos-once="false"
                >
                  <div :class="isMobile ? '' : 'card-title'">
                    <a :href="'/ArticleView/' + item.guid">
                      <h2 class="pt-1" :class="isMobile ? ' fs11px' : 'fs-6'">
                        {{ getArticleTitle(item.title) }}
                      </h2>
                    </a>
                  </div>

                  <div class="my-1">
                    <a :href="'/ArticleView/' + item.guid"
                      ><img
                        width="350"
                        :alt="item.englishTitle + ' ' + item.title"
                        :src="`${this.$store.state.apiBaseURL}/ST/Article/GetArticleImage?id=${item.id}`"
                    /></a>
                  </div>

                  <!-- <div
                    class="card-body ps-0 pe-0 text-gray-500"
                    v-if="!isMobile"
                  >
                    <hr class="my-1" />
                    <div class="clearfix mb-2">
                      <a
                        :href="'/ArticleView/' + item.guid"
                        class="text-gray-700 ltr"
                        dir="ltr"
                        >{{ item.englishTitle }}</a
                      >
                      <p class="px-2 smaller text-gray-700">
                        <i class="fi fi-calendar"></i>
                        {{ getPersianPublishDate(item.publishDate) }}
                      </p>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <!-- <div class="text-align-center my-2" v-if="!isMobile">
              <a href="/articles" class="btn btn-soft btn-light btn-sm">
                <i class="fi fi-arrow-start"></i>
                <span>مشاهده همه مقالات</span>
                <i class="fi fi-arrow-end"></i>
              </a>
            </div> -->

            <div class="text-start">
              <a
                href="/articles"
                class="btn btn-soft text-secondary btn-sm fs11px ps-0"
                :class="isMobile ? 'fs11px' : 'fs15px'"
              >
                <span>مشاهده همه</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        class="section bg-light text-center sectionQuestion"
        :class="isMobile ? 'pt-4 pb-1' : 'mt-3'"
      >
        <div class="container">
          <h2 v-if="!isMobile" class="fw-bold">آخرین پاسخ ها</h2>
          <hr v-if="!isMobile" class="bg-gradient-primary my-0 container" />
          <div class="row pt-1" :class="isMobile ? 'g-1' : ''">
            <div
              v-for="item in newQuestions"
              :key="item.guid"
              class="col-4"
              :class="isMobile ? 'col-4' : 'col-12 col-md-12 col-lg-4 mb-5'"
            >
              <div
                class="card border-0 bg-white h-100 shadow rounded-xl question-card"
                :class="isMobile ? '' : 'aos-init aos-animate'"
                data-aos="fade-down"
                data-aos-delay="100"
                data-aos-offset="0"
                data-aos-once="false"
              >
                <div class="text-center pt-2 pe-2 bg-gray-300">
                  <a :href="'/questionAnswerView/' + item.guid"
                    ><h3
                      class="fs-5 text-end text-gray-800 py-2"
                      :class="isMobile ? 'fs11px' : 'fw-bold '"
                    >
                      <!-- <svg
                        v-if="!isMobile"
                        width="40px"
                        height="40px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-question-circle"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        ></path>
                        <path
                          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                        ></path>
                      </svg> -->
                      پرسش {{ item.questionNumber }}
                    </h3>
                    <!-- <p
                      class="smaller m-0 text-gray-700"
                      :class="isMobile ? 'fs10px' : 'px-2 text-start '"
                      v-if="!isMobile"
                    >
                      <i class="fi fi-calendar"></i>
                      {{ getPersianPublishDate(item.publishDate) }}
                    </p> -->
                  </a>
                </div>

                <div
                  class="card-body"
                  :class="isMobile ? 'pb-1' : ''"
                  :style="isMobile ? 'min-height: unset !important' : ''"
                >
                  <a :href="'/questionAnswerView/' + item.guid"
                    ><p
                      class="text-gray-900"
                      :class="isMobile ? 'fs10px' : 'text-end text-justified'"
                    >
                      {{ item.questionAbstract }}
                    </p></a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="text-align-center mt-2" v-if="!isMobile">
            <a href="/questionAnswers" class="btn btn-soft btn-light btn-sm">
              <i class="fi fi-arrow-start"></i>
              <span>مشاهده همه پرسش ها</span>
              <i class="fi fi-arrow-end"></i>
            </a>
          </div> -->

          <div class="text-start mt-1">
            <a
              href="/questionAnswers"
              class="btn btn-soft text-secondary btn-sm ps-0"
              :class="isMobile ? 'fs11px' : 'fs15px'"
            >
              <span>مشاهده همه</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <template v-else>
      <div
        class="container d-flex justify-content-center align-items-center"
        style="height: 45vh; font-size: 0.8em"
      >
        <div>
          <div
            class="row"
            style="width: 100vw"
            v-if="this.$store.getters.isAuthenticated"
          >
            <div class="col-3 p-1">
              <a
                href="#"
                @click="reserveButtonInMobile"
                class="link-normal rounded text-danger d-block text-center animate-pulse-danger"
              >
                <div class="mt-2">
                  <h6 class="mb-0 fs-7 fw-bold">جلسه‌درمانی</h6>
                </div>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                href="#"
                @click="reserveTestButtonInMobile"
                class="link-normal rounded text-purple d-block text-center animate-pulse-primary"
              >
                <div class="mt-2">
                  <h6 class="mb-0 fs-7 fw-bold">تست و ارزیابی</h6>
                </div>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                :href="`/panel/workshopTab/${$store.getters.userPersonID}/1`"
                class="link-normal rounded text-secondary d-block text-center"
              >
                <div class="mt-2">
                  <h6
                    class="mb-0 fs-7 fw-bold position-relative text-success animate-pulse-success"
                  >
                    گروه‌درمانی
                  </h6>
                </div>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                :href="`/panel/workshopTab/${$store.getters.userPersonID}/2`"
                class="link-normal rounded text-secondary d-block text-center animate-pulse-warning"
              >
                <div class="mt-2">
                  <h6 class="mb-0 fs-7 fw-bold">
                    <label class="position-relative text-orange">کارگاه </label>
                  </h6>
                </div>
              </a>
            </div>
          </div>
          <hr
            class="bg-dark my-3 container"
            v-if="this.$store.getters.isAuthenticated"
          />
          <div class="row" style="width: 100vw">
            <div class="col-3 p-1">
              <a
                href="/faq"
                class="link-normal rounded text-muted d-block text-center"
              >
                <h6 class="mb-0" :class="isMobile ? 'fs-7' : ''">FAQ</h6>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                href="/articles"
                class="link-normal rounded d-block text-center"
              >
                <h6 class="mb-0 fs-7">آرشیو مقاله‌ها</h6>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                href="/questionAnswers"
                class="link-normal rounded d-block text-center"
              >
                <h6 class="mb-0 fs-7">پرسش‌و‌پاسخ</h6>
              </a>
            </div>
            <div class="col-3 p-1">
              <a
                href="/contactUs"
                class="link-normal rounded d-block text-muted text-center"
              >
                <h6 class="mb-0 fs-7">تماس‌با‌ما</h6>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import { isMobile, isIOS, isSafari } from 'mobile-device-detect';

export default {
  data() {
    return {
      isMobile: isMobile,
      isIOS: isIOS,
      isSafari: isSafari,
      visibleAddHomeScreen: false,
      newArticles: [],
      newQuestions: [],
    };
  },
  inject: [
    'showCertificates',
    'reservingSessionFunction',
    'reservingTestSessionFunction',
  ],
  components: {},
  computed: {
    checkPassPWA() {
      if (localStorage.getItem('usePWA')) return false;
      return true;
    },
  },
  methods: {
    reserveButtonInMobile() {
      if (this.$store.getters.isAuthenticated) {
        this.$router.push({
          name: 'selectTherapist',
          params: { id: this.$store.getters.userPersonID },
        });
      } else {
        // document.getElementById('reservePreLoginModalTrigger').click();
        this.reservingSessionFunction(false);
      }
    },
    reserveTestButtonInMobile() {
      if (this.$store.getters.isAuthenticated) {
        this.$router.push({
          name: 'selectTestSession',
          params: { id: this.$store.getters.userPersonID },
        });
      } else {
        // document.getElementById('reserveTestPreLoginModalTrigger').click();
        this.reservingTestSessionFunction(false);
      }
    },
    closeAddHomeScreenMessage() {
      this.visibleAddHomeScreen = false;
      localStorage.setItem('usePWA', 'true');
    },
    async getLatestArticles() {
      let that = this;

      await axios
        .get('/ST/Article/GetLatestArticles')
        .then((response) => {
          that.newArticles = response.data;
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          // this.$refs.spinner.hide();
        });
    },
    async getLatestQuestions() {
      let that = this;
      await axios
        .get('/ST/QuestionAnswer/GetLatestQuestions')
        .then((response) => {
          that.newQuestions = response.data;
        })
        .catch(() => {
          // this.$refs.notification.show({
          //   type: 'error',
          //   title: `عملیات ویرایش ردیف انتخاب شده با خطا مواجه گردید`,
          // });
        })
        .finally(() => {
          // this.$refs.spinner.hide();
        });
    },
    // async getArticleImage(id) {
    //   // let ele = el;
    //   // let that = this;
    //   // that.$refs.spinner.show();
    //   await axios
    //     .get('/ST/Article/GetArticleImage?id=' + id, {
    //       responseType: 'blob',
    //     })
    //     .then(() => {
    //       return '/contents/images/No-Image.png';
    //       // // console.log(ele);
    //       // if (response.data.size == 0) {
    //       //   return '/contents/images/No-Image.png';
    //       // } else {
    //       //   return URL.createObjectURL(response.data);
    //       // }
    //     })
    //     .catch(() => {
    //       // that.demoImageUrl = '/contents/images/No-Image.png';
    //       // if (error.response.statusText == 'Unauthorized') {
    //       //   // this.$router.push({ path: '/login' });
    //       //   return;
    //       // }
    //       // if (!error.response.data.success) {
    //       //   let errorMessages = error.response.data.errors.map(
    //       //     (i) => i.errorMessage
    //       //   );
    //       //   errorMessages.forEach((item) => {
    //       //     that.$refs.notification.show({
    //       //       type: 'error',
    //       //       title: item,
    //       //     });
    //       //   });
    //       // }
    //     })
    //     .finally(() => {
    //       // that.$refs.spinner.hide();
    //     });
    // },
    getPersianPublishDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('LLLLL');
    },
    slidImageClick() {
      if (this.$store.getters.isAuthenticated) {
        this.$router.push({
          name: 'userPanel',
          params: { id: this.$store.getters.userPersonID },
        });
      } else {
        this.$router.push({
          name: 'login',
        });
      }
    },
    getArticleTitle(title) {
      if (isMobile) {
        if (title.length > 22) {
          return title.substr(0, 19) + '...';
        }
        return title;
      }
      return title;
    },
  },
  async mounted() {
    await this.getLatestArticles();
    await this.getLatestQuestions();
    if (!this.isMobile) {
      await this.getLatestArticles();
      await this.getLatestQuestions();
    } else {
      let homeMobileButton = document.getElementById('homeMobileButton');
      if (homeMobileButton) homeMobileButton.style.display = 'none';
      let menuBoxButton = document.getElementById('menuBoxButton');
      if (menuBoxButton) menuBoxButton.style.opacity = 0;
      document.getElementsByClassName(
        'serviceButtonContainer'
      )[0].style.display = 'none';
      // document.getElementsByClassName('testButtonContainer')[0].style.display =
      //   'none';

      // document.getElementsByClassName(
      //   'groupTherapyButtonContainer'
      // )[0].style.display = 'none';

      // document.getElementsByClassName(
      //   'workshopButtonContainer'
      // )[0].style.display = 'none';
    }

    if (
      !window.matchMedia('(display-mode: standalone)').matches &&
      this.isMobile
    ) {
      this.visibleAddHomeScreen = true;
      // do things here
      // set a variable to be used when calling something
      // e.g. call Google Analytics to track standalone use
    }
  },
};
</script>
<style scopped>
@media (max-width: 870px) {
  .slide1 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-01.jpg?version=1.4.1);
  }
  .slide2 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-02.jpg?version=1.4.1);
  }
  .slide3 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-03.jpg?version=1.4.1);
  }
  .slide4 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-04.jpg?version=1.4.1);
  }
  /* .slide5 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-05.jpg);
  }
  .slide6 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-06.jpg);
  }
  .slide7 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-07.jpg);
  } 
  .slide8 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-08.jpg);
  }
  .slide9 {
    background-image: url(../assets/images/siteImages/Banner/960x480/organic-minded-web-banners-960x480-09.jpg);
  }*/
}

@media (min-width: 870.1px) {
  .slide1 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-01.jpg?version=1.4.1);
  }
  .slide2 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-02.jpg?version=1.4.1);
  }
  .slide3 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-03.jpg?version=1.4.1);
  }
  .slide4 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-04.jpg?version=1.4.1);
  }
  /* .slide5 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-05.jpg);
  }
  .slide6 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-06.jpg);
  }
  .slide7 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-07.jpg);
  } 
  .slide8 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-08.jpg);
  }
  .slide9 {
    background-image: url(../assets/images/siteImages/Banner/1920x960/organic-minded-web-banners-1920x960-09.jpg);
  } */
}

.addHomeScreen {
  z-index: 20000;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  padding: 25px;
  right: 0;
  color: #3b3b3b;
  opacity: 0.98;
  padding-bottom: 150px;
}
.addHomeScreen .close {
  width: 100%;
  font-size: 1.5rem;
}
.addHomeScreen .close .close-button {
  cursor: pointer;
  background: #506690;
  width: 30px;
  height: 30px;
  margin-left: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
}
.addHomeScreen .message {
  display: block;
  text-align: center;
  padding: 0 20px;
  margin-bottom: 35px;
}
.addHomeScreenItems {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  font-size: 12px;
}
.addHomeScreenItems > img {
  width: 16px;
}
</style>
